fragment AutomationActionFragment on Action {
    id
    type
    config {
        ... on ActionConfigAddTags {
            tags {
                id
                name
                color
            }
        }
        ... on ActionConfigAddAudiences {
            audiences {
                id
                name
            }
        }
        ... on ActionConfigRemoveAudiences {
            audiences {
                id
                name
            }
        }
        ... on ActionConfigSendPageViewedNotification {
            notifiables {
                ... on User {
                    id
                    name
                }
                ... on NotifiableAlias {
                    type
                }
            }
        }
        ... on ActionConfigAddToDripSequence {
            dripSequence {
                id
                name
            }
        }
        ... on ActionConfigCreateLead {
            stageset {
                id
                name
            }
            tags {
                id
                name
            }
            assigneeOrRule {
                ... on User {
                    id
                    name
                }
                ... on Team {
                    id
                    name
                }
                ... on LeadAssigneeRule {
                    assignmentRule
                }
            }
        }
    }
    humanReadableTitle
}
